var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"dr-biz-msg",on:{"click":_vm.go}},[_c('el-badge',{attrs:{"value":_vm.badge,"hidden":!_vm.badge,"max":99}},[_c('i',{staticClass:"el-icon-bell dr-biz-msg__icon"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }